import { CogfyClient } from '@indigohive/cogfy-api-client'
import { createContext } from 'react'

export const CogfyClientContext = createContext<CogfyClient>(null!)
